import React from "react";
import { Badge, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./LeaveRequestModal.scss";
import { BASE_URL } from "config/config";

function LeaveRequestModal({ leaveRequest, onClose }) {
  const { t } = useTranslation();

  if (!leaveRequest) return null;

  function getFileURL(path) {
    return `${BASE_URL}${path.replace(/\\/g, "/")}`;
  }

  return (
    <div className="leave-request-modal">
      <div className="modal-body">
        {/* Infos générales */}
        <section className="info-section">
          <h5>{t("congeList.leaves.modal.information")}</h5>
          <ul>
            <li>
              <strong>{t("congeList.leaves.form.comment")}: </strong>
              {leaveRequest.comment || "—"}
            </li>
            <li>
              <strong>{t("congeList.leaves.form.justification")}: </strong>
              {leaveRequest.justification ? (
                <a
                  href={getFileURL(leaveRequest.justification)}
                  target="_blank"
                  rel="noopener noreferrer">
                  {t("congeList.leaves.form.download_justif")}
                </a>
              ) : (
                t("congeList.leaves.form.notAvailable")
              )}
            </li>
            <li>
              <strong>{t("congeList.leaves.form.status")}: </strong>
              <Badge bg={leaveRequest.isValide ? "success" : "secondary"}>
                {leaveRequest.isValide
                  ? t("congeList.common.valid")
                  : t("congeList.common.pending")}
              </Badge>
            </li>
            <li>
              <strong>{t("congeList.leaves.form.createdAt")}: </strong>
              {new Date(leaveRequest.createdAt.$date).toLocaleDateString()}
            </li>
            <li>
              <strong>{t("congeList.leaves.form.updatedAt")}: </strong>
              {new Date(leaveRequest.updatedAt.$date).toLocaleDateString()}
            </li>
          </ul>
        </section>

        {/* Tableau des congés */}
        <section className="info-section">
          <h5>{t("congeList.leaves.modal.details")}</h5>
          <Table bordered hover responsive size="sm" className="leave-table">
            <thead>
              <tr>
                <th>{t("congeList.leaves.form.type")}</th>
                <th>{t("congeList.leaves.form.calendar")}</th>
                <th>{t("congeList.leaves.form.createdAt")}</th>
                <th>{t("congeList.leaves.form.updatedAt")}</th>
              </tr>
            </thead>
            <tbody>
              {leaveRequest.leaves?.map((lv, idx) => (
                <tr key={idx}>
                  <td>{lv.type}</td>
                  <td>
                    {lv.calendarNotes &&
                      Object.entries(lv.calendarNotes)
                        .map(([date, value]) => `${date}: ${value}`)
                        .join(", ")}
                  </td>
                  <td>
                    {lv.createdAt?.$date
                      ? new Date(lv.createdAt.$date).toLocaleDateString()
                      : "—"}
                  </td>
                  <td>
                    {lv.updatedAt?.$date
                      ? new Date(lv.updatedAt.$date).toLocaleDateString()
                      : "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </section>
      </div>
    </div>
  );
}

export default LeaveRequestModal;
